export default function Error({ code, title, subtitle, route = '/' }) {
  return (
    <div className='container bg-brown-200 h-[50vh] flex flex-col justify-center items-start gap-8 mb-16'>
      <h1 className='hero'>{code}</h1>
      <h2>{title}</h2>
      <p>{subtitle}</p>
      <a href={route} className='button-dark'>
        Go Home
      </a>
    </div>
  );
}
